module.exports = __webpack_public_path__ + "img/img_level_4.a9e6f082.png";